export default "__VITE_ASSET__z62xcUot__"